import { useTranslation } from 'react-i18next';

import { Alert } from '@pulse-web-ui/alert';

import { ContainerWithPadding } from '@shared/ui';

import { AlertTitle } from './draft-alert.styles';

export const DraftAlert = () => {
  const { t } = useTranslation();

  return (
    <ContainerWithPadding $margin='0 0 24px 0'>
      <Alert
        type='info'
        title={<AlertTitle>{t('AGENT_PROFILE:banners.alertTitle')}</AlertTitle>}
        description={t('AGENT_PROFILE:banners.alertDescription')}
      />
    </ContainerWithPadding>
  );
};
